import React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useDarkModeToggle } from "../../contexts/DarkMode.js";
export const DarkModeToggle = ({
  label
}) => {
  const toggleDarkMode = useDarkModeToggle();
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      onClick: toggleDarkMode
    }),
    label: label
  });
};
DarkModeToggle.displayName = 'DarkModeToggle';
export default DarkModeToggle;